document.addEventListener("DOMContentLoaded", () => {
    let swiper_activity = new Swiper(".activities-section .swiper-container", {
        grabCursor: true,
        centeredSlides: true,
        initialSlide: 2,
        spaceBetween: 20,
        slidesPerView: 6,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            1440: {
                slidesPerView: 5,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 2.5,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 1.3,
                spaceBetween: 30,
            },
            0: {
                slidesPerView: 1.3,
                spaceBetween: 30,
            },
        },
    });
});